/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tolerance_Band_ToInputs */

const en_tolerance_band_to = /** @type {(inputs: Tolerance_Band_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To units`)
};

/**
* | output |
* | --- |
* | "To units" |
*
* @param {Tolerance_Band_ToInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const tolerance_band_to = /** @type {((inputs?: Tolerance_Band_ToInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tolerance_Band_ToInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_tolerance_band_to(inputs)
});